export default __webpack_public_path__ + "static/media/marcio.37bc09be.png";